<template>
    <b-row>
        <b-col md="3">
            <indicator-card-work-schedule-statement
                ref="chartPosActive"
                :title="i18nPosActive"
                :busy="loading"
                :value="posActive"
                color="black"
            />
        </b-col>
        <b-col md="3">
            <indicator-card-work-schedule-statement
                ref="chartTotalVisitsBooked"
                :title="i18nTotalVisitsBooked"
                :busy="loading"
                :value="totalVisitsBooked"
                color="black"
            />
        </b-col>
        <b-col md="3">
            <indicator-card-work-schedule-statement
                ref="chartTotalVisitsCarriedOut"
                :title="i18nTotalVisitsCarriedOut"
                :busy="loading"
                :value="totalVisitsCarriedOut"
                color="black"
            />
        </b-col>
        <b-col md="3">
            <indicator-card-work-schedule-statement
                ref="chartPercentagePerformance"
                :title="i18PercentagePerformance"
                :busy="loading"
                :value="percentagePerformance"
                type="percentage"
                color="black"
            />
        </b-col>
    </b-row>
</template>

<script>
    import WorkScheduleStatementService from '@/src/services/dashboards/widgets/WorkScheduleStatementService'
    import swalFeedback from '@src/mixins/swalFeedback.vue'
    import validationMixin from '@src/mixins/validation.vue'
    import IndicatorCardWorkScheduleStatement from '@/src/components/dashboards/IndicatorCardWorkScheduleStatement'

    const i18nKey = 'DASHBOARDS'

    export default {
        components: {
            IndicatorCardWorkScheduleStatement,
        },
        mixins: [
            validationMixin,
            swalFeedback,
        ],
        data() {
            return {
                i18nKey,
                loading: false,
                posActive: 0,
                totalVisitsBooked: 0,
                totalVisitsCarriedOut: 0,
                posWithWorkScheduleStatement: 0,
                percentagePerformance: 0,
            }
        },
        validations: {},
        computed: {
            i18nPosActive() {
                return this.getI18n(i18nKey, 'TITLES.pos_routed')
            },
            i18nTotalVisitsBooked() {
                return this.getI18n(i18nKey, 'TITLES.total_visits_booked')
            },
            i18nTotalVisitsCarriedOut() {
                return this.getI18n(i18nKey, 'TITLES.total_visits_carried_out')
            },
            i18PercentagePerformance() {
                return this.getI18n(i18nKey, 'TITLES.percentage_performance')
            },
        },
        methods: {
            refresh(parameters) {
                this.loading = true
                this.posActive = 0
                this.totalVisitsBooked = 0
                this.totalVisitsCarriedOut = 0
                this.posWithWorkScheduleStatement = 0
                this.percentagePerformance = 0

                WorkScheduleStatementService.resume(parameters)
                    .then((response) => {
                        this.posActive = response.data.data.pos_active
                        this.totalVisitsBooked = response.data.data.total_visits_booked
                        this.totalVisitsCarriedOut = response.data.data.total_visits_carried_out
                        this.posWithWorkScheduleStatement = response.data.data.pos_with_work_schedule_statement ?? 0
                        this.percentagePerformance = this.totalVisitsBooked > 0
                            ? Math.round(this.totalVisitsCarriedOut * 100 / this.totalVisitsBooked)
                            : 0
                        this.loading = false
                    })
                    .catch((err) => {
                        this.loading = false
                        return err
                    })
            }
        },
    }
</script>
